import { createContext, useContext, useMemo, useState, type ReactNode } from "react";
import {
  useConsultationTranscriptionController,
  type TranscriptionSessionConfig,
} from "@/components/medical-records/transcription/useConsultationTranscriptionController";

type TranscriptionContextValue = ReturnType<typeof useConsultationTranscriptionController>;

const TranscriptionContext = createContext<TranscriptionContextValue | undefined>(undefined);

interface TranscriptionProviderProps {
  children: ReactNode;
}

export const TranscriptionProvider = ({ children }: TranscriptionProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [session, setSession] = useState<TranscriptionSessionConfig | null>(null);
  const controller = useConsultationTranscriptionController({
    isOpen,
    isMinimized,
    session,
    setIsOpen,
    setIsMinimized,
    setSession,
  });

  const value = useMemo(
    () => controller,
    [controller],
  );

  return <TranscriptionContext.Provider value={value}>{children}</TranscriptionContext.Provider>;
};

export const useTranscription = () => {
  const context = useContext(TranscriptionContext);
  if (!context) {
    throw new Error("useTranscription must be used within a TranscriptionProvider");
  }
  return context;
};
